import styled, { css } from "styled-components";
import { TabPanel as TabPanelPrimitive } from "react-aria-components";
import { useDesignTokens } from "@boi/react-design-tokens";

import type { TabListView } from "./Tabs.types";

type DesktopTabListWrapperProps = {
  $tabListView: TabListView;
};

export const DesktopTabListWrapper = styled.div<DesktopTabListWrapperProps>`
  ${({ $tabListView }) => {
    const { tokens } = useDesignTokens();
    const { tabs } = tokens;

    return [
      css`
        display: inline-grid;
        padding-right: ${tabs.desktop.container.padding.right};
      `,
      (!$tabListView || $tabListView === "mobile") &&
        css`
          height: 1px;
          overflow: hidden;
          visibility: hidden;
        `,
    ];
  }}
`;

export const TabPanels = styled.div`
  ${() => {
    const { tokens } = useDesignTokens();
    const { tabs } = tokens;

    return css`
      border-top-width: ${tabs.panel.strokeTop.width};
      border-top-style: ${tabs.panel.strokeTop.style};
      border-top-color: ${tabs.panel.strokeTop.color};
    `;
  }}
`;

type TabPanelProps = {
  $withIcon: boolean;
  $withPadding: boolean;
};

export const TabPanel = styled(TabPanelPrimitive)<TabPanelProps>`
  ${({ $withIcon, $withPadding }) => {
    const { tokens } = useDesignTokens();
    const { tabs } = tokens;

    return [
      css`
        background: ${tabs.panel.backgroundColor};

        &:focus-visible {
          position: relative;
          z-index: 1;
          outline-width: ${tabs.panel.focusRing.width};
          outline-style: ${tabs.panel.focusRing.style};
          outline-color: ${tabs.panel.focusRing.color};
        }
      `,
      $withPadding &&
        css`
          padding-top: ${tabs.panel.padding.top};
          padding-bottom: ${tabs.panel.padding.bottom};
          padding-left: ${tabs.panel.padding.left.base};
          padding-right: ${tabs.panel.padding.right.base};
        `,
      $withIcon &&
        $withPadding &&
        css`
          padding-left: ${tabs.panel.padding.left.withIcon};
          padding-right: ${tabs.panel.padding.right.withIcon};
        `,
    ];
  }}
`;
